import { Box, Typography } from '@mui/material';

const KEY_POINTS = [
  'ללא התחייבות — ניתן לבטל בכל עת',
  'התקנה פיזית חינם — שירות VIP',
  'מיני-מחשב בפיקדון ₪250 — אם מבטלים בתום 4 חודשי החינם ומחזירים את המכשיר, הפיקדון מוחזר במלואו',
  'תנאי: משוב חודשי קצר',
];

const EQUIPMENT_DETAILS = [
  'מסך: כל מסך מתאים (גם קיים) — עדיף מעל 40 אינץ׳ אך לא חובה. רוצים שנרכוש עבורכם? מסך 50 אינץ׳ בכ-₪800',
  'אינטרנט: חובה. אם יש לכם — מעולה, אין צורך בשום דבר נוסף. אם אין — נספק אינטרנט סלולרי ייעודי לתוכנה ב-₪12/חודש',
  'התקנה פיזית: הגעה, חיווט, תלייה והגדרה — חינם',
];

/* ── Price cards (replaces numbered timeline) ────────────────────── */
const PriceCards = ({ compact }) => (
  <Box sx={{
    display: 'flex',
    gap: compact ? 1.5 : 2,
    mb: 0.5,
    mt: compact ? 1.5 : 2,
  }}>
    {/* Free card */}
    <Box sx={{
      flex: 1,
      bgcolor: 'rgba(74,222,128,0.1)',
      border: '1.5px solid rgba(74,222,128,0.35)',
      borderRadius: 2.5,
      p: compact ? 1.5 : 2,
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        background: 'radial-gradient(ellipse at center, rgba(74,222,128,0.08) 0%, transparent 70%)',
        pointerEvents: 'none',
      },
    }}>
      <Typography sx={{
        fontFamily: 'Heebo, sans-serif',
        fontSize: compact ? '0.7rem' : '0.78rem',
        color: 'rgba(255,255,255,0.6)',
        mb: 0.5,
      }}>
        חודשים 1-4
      </Typography>
      <Typography sx={{
        fontFamily: 'Frank Ruhl Libre, serif',
        fontSize: compact ? '2rem' : '2.5rem',
        fontWeight: 900,
        color: '#4ade80',
        lineHeight: 1,
        textShadow: '0 0 24px rgba(74,222,128,0.5)',
      }}>
        חינם
      </Typography>
      <Typography sx={{
        fontFamily: 'Heebo, sans-serif',
        fontSize: compact ? '0.65rem' : '0.7rem',
        fontWeight: 700,
        color: '#4ade80',
        mt: 0.5,
      }}>
        ₪0
      </Typography>
    </Box>

    {/* 50% off card */}
    <Box sx={{
      flex: 1,
      bgcolor: 'rgba(251,191,36,0.08)',
      border: '1.5px solid rgba(251,191,36,0.3)',
      borderRadius: 2.5,
      p: compact ? 1.5 : 2,
      textAlign: 'center',
    }}>
      <Typography sx={{
        fontFamily: 'Heebo, sans-serif',
        fontSize: compact ? '0.7rem' : '0.78rem',
        color: 'rgba(255,255,255,0.6)',
        mb: 0.5,
      }}>
        חודשים 5-12
      </Typography>
      {/* Original price strikethrough */}
      <Typography sx={{
        fontFamily: 'Frank Ruhl Libre, serif',
        fontSize: compact ? '0.85rem' : '0.95rem',
        color: 'rgba(255,255,255,0.3)',
        textDecoration: 'line-through',
        lineHeight: 1,
      }}>
        ₪72
      </Typography>
      <Typography sx={{
        fontFamily: 'Frank Ruhl Libre, serif',
        fontSize: compact ? '1.6rem' : '2rem',
        fontWeight: 900,
        color: '#fbbf24',
        lineHeight: 1,
      }}>
        ₪36
        <Box component="span" sx={{ fontSize: '0.55em', color: 'rgba(255,255,255,0.5)' }}>/חודש</Box>
      </Typography>
      {/* 50% badge */}
      <Box sx={{
        display: 'inline-flex',
        bgcolor: 'rgba(251,191,36,0.18)',
        border: '1px solid rgba(251,191,36,0.45)',
        borderRadius: '10px',
        px: 1,
        py: 0.2,
        mt: 0.5,
      }}>
        <Typography sx={{
          fontFamily: 'Heebo, sans-serif',
          fontWeight: 800,
          fontSize: compact ? '0.72rem' : '0.78rem',
          color: '#fbbf24',
        }}>
          50% הנחה
        </Typography>
      </Box>
    </Box>
  </Box>
);

/* ── Key points bullets ──────────────────────────────────────────── */
const KeyPoints = ({ compact }) => (
  <Box sx={{ mb: compact ? 2 : 2.5 }}>
    {KEY_POINTS.map((point, i) => (
      <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 0.6 }}>
        <Box component="span" sx={{ color: '#4ade80', fontSize: compact ? '0.78rem' : '0.85rem', mt: '2px', flexShrink: 0 }}>✓</Box>
        <Typography sx={{
          color: 'rgba(255,255,255,0.9)',
          fontFamily: 'Heebo, sans-serif',
          fontSize: compact ? '0.78rem' : '0.85rem',
          lineHeight: 1.6,
        }}>
          {point}
        </Typography>
      </Box>
    ))}
  </Box>
);

/* ── Equipment details ───────────────────────────────────────────── */
const EquipmentDetails = () => (
  <Box>
    <Typography sx={{
      fontFamily: 'Heebo, sans-serif',
      fontSize: '0.72rem',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: '#d4a017',
      mb: 1,
    }}>
      פרטי ציוד ושירות
    </Typography>
    {EQUIPMENT_DETAILS.map((detail, i) => (
      <Typography key={i} sx={{
        fontFamily: 'Heebo, sans-serif',
        fontSize: '0.75rem',
        color: 'rgba(255,255,255,0.65)',
        lineHeight: 1.9,
      }}>
        {detail}
      </Typography>
    ))}
  </Box>
);

/**
 * PioneerContent — shared content for banner and popup.
 * Props:
 *   compact  {boolean}   — popup mode (single column, smaller)
 *   ctaSlot  {ReactNode} — CTA button, placed in details column on desktop
 */
const PioneerContent = ({ compact = false, ctaSlot }) => {
  /* ── Headline block ── */
  const headline = (
    <>
      {/* Chip */}
      <Box sx={{
        display: 'inline-flex',
        bgcolor: 'rgba(154,114,9,0.25)',
        border: '1px solid rgba(154,114,9,0.6)',
        borderRadius: '20px',
        px: 1.75,
        py: 0.5,
        mb: 2,
      }}>
        <Typography sx={{
          color: '#fbbf24',
          fontFamily: 'Heebo, sans-serif',
          fontWeight: 700,
          fontSize: '0.82rem',
        }}>
          תכנית חלוצים
        </Typography>
      </Box>

      {/* Headline */}
      <Typography component="h3" sx={{
        fontFamily: 'Frank Ruhl Libre, serif',
        fontSize: compact ? { xs: '1.4rem', md: '1.7rem' } : { xs: '1.7rem', md: '2.2rem' },
        fontWeight: 900,
        color: 'white',
        mb: 1,
        lineHeight: 1.3,
      }}>
        <Box component="span" sx={{ color: '#4ade80', textShadow: '0 0 24px rgba(74,222,128,0.4)' }}>4 חודשים חינם</Box>
        {'. '}
        <Box component="span" sx={{ color: '#fbbf24' }}>8 חודשים ב-50% הנחה</Box>
        {'.'}
      </Typography>

      {/* Subtitle */}
      <Typography sx={{
        color: 'rgba(255,255,255,0.8)',
        fontFamily: 'Heebo, sans-serif',
        fontSize: compact ? '0.85rem' : '0.95rem',
        lineHeight: 1.8,
        mb: 0,
      }}>
        מוגבל ל-<Box component="span" sx={{ color: 'white', fontWeight: 700 }}>20 קהילות ראשונות</Box> בלבד — מסלול נֵר בתנאים שלא יחזרו
      </Typography>

      {/* Price cards */}
      <PriceCards compact={compact} />
      <Typography sx={{
        fontFamily: 'Heebo, sans-serif',
        fontSize: '0.72rem',
        color: 'rgba(255,255,255,0.45)',
        mb: compact ? 2 : 0,
        textAlign: 'center',
      }}>
        לאחר מכן — תשלום חודשי רגיל (₪72)
      </Typography>
    </>
  );

  /* ── Details block ── */
  const details = (
    <>
      <KeyPoints compact={compact} />
      <EquipmentDetails />
      {ctaSlot && <Box sx={{ mt: 3 }}>{ctaSlot}</Box>}
    </>
  );

  /* ── Compact: single column (popup) ── */
  if (compact) {
    return (
      <Box>
        {headline}
        {details}
      </Box>
    );
  }

  /* ── Full: two columns (banner) ── */
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      gap: { xs: 3, md: 5 },
    }}>
      {/* Right column (RTL) — headline + price cards */}
      <Box sx={{ flex: { md: '1 1 55%' } }}>
        {headline}
      </Box>
      {/* Left column (RTL) — details + CTA, aligned to headline */}
      <Box sx={{
        flex: { md: '1 1 45%' },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        pt: { md: '88px' }, // align with the headline (skip chip height)
      }}>
        {details}
      </Box>
    </Box>
  );
};

export default PioneerContent;
